import { useState } from 'react'
import Container from 'react-bootstrap/Container'
import { dehydrate, QueryClient } from 'react-query'
import { getLegalDocs } from 'src/@shared/service/cms-api'
import ServicesHeroImage from '@assets/img/services-hero.webp'
import PowerBlockchainImage from '@assets/img/power-of-blockchain.webp'
import BlockchainEra from '@modules/professional-services/components/BlockchainEra/BlockchainEra'
import SlideOffer from '@modules/professional-services/components/SlideOffer/SlideOffer'
import CardsSection from '@modules/professional-services/components/CardsSection/CardsSection'

import CustomHead from '@atk/components/head/customHead/customHead'
import Hero from '@atk/components/hero/Hero/Hero'
import Newsletter2 from '@atk/components/newsletter/Newsletter2/Newsletter2'
import CTARight from '@atk/components/cta/CTARight/CTARight'
import AccordionComponent from '@atk/components/accordion/Accordion/Accordion'
import HotspotModal from '@atk/components/layout/Modal/HotspotModal'

import FramerMotion from '@atk/hooks/framerMotion'

const initialArgs = { sort: 'position', limit: 0, page: 1 }

export async function getServerSideProps() {
    const queryClient = new QueryClient()
    // prefetch data on the server
    await queryClient.fetchQuery(['legaldocs'], () => getLegalDocs(initialArgs))
    return {
        props: {
            // dehydrate query cache
            dehydratedState: dehydrate(queryClient),
        },
    }
}

export default function Services() {
    const [showEbookModal, setShowEbookModal] = useState(false)
    const handleClose = () => setShowEbookModal(false)

    const heroTitle = `Customized Software and <span class="text-green">Dedicated Services</span>`
    const accordionTitle = `Our <span class="text-purple">Engagement</span> Models`
    const AccordionItems = [
        {
            title: 'Educate and Engage',
            desc: 'Learn the many advantages of the Casper Blockchain and connect these to real business problems.',
        },
        {
            title: 'Implement and Grow',
            desc: 'After integrating new solutions, we help you to scale into new business opportunities.',
        },
        {
            title: 'Productize',
            desc: 'Use proven solutions to create vertical-specific feature deployments at scale.',
        },
    ]
    const pageClass = `overflow-hidden servicesPage`
    const isMobile = typeof window !== 'undefined' ? window.innerWidth <= 768 : false

    return (
        <>
            <CustomHead
                title="Hybrid Blockchain Solutions & Services | Casper Labs"
                description="Unlock blockchain's potential with Casper Labs' professional services. Tap into our unique hybrid blockchain solutions tailored to your business needs."
            >
                <link rel="preload" href={ServicesHeroImage.src} as="image" />
                {!isMobile && <link rel="preload" href={PowerBlockchainImage.src} as="image" />}
            </CustomHead>
            <FramerMotion animation="fadeIn">
                <div className={pageClass}>
                    <main>
                        <Hero
                            isHeader
                            customClass="heroServices pt-0 pb-0"
                            col1={6}
                            col2={6}
                            halfTitle="our services"
                            title={heroTitle}
                            desc="Tap into proven software development expertise, innovative design methodologies, and a veteran professional services team. Build on the blockchain that fits directly into your existing technology stack."
                            linkButton={{
                                label: 'GET IN TOUCH',
                                link: '/contact?section=contactForm',
                                variant: 'secondary',
                            }}
                            bgImage={ServicesHeroImage.src}
                        ></Hero>
                        <CTARight
                            col1={8}
                            col2={4}
                            customClass="servicesCTA"
                            halfTitle="New to blockchain ebook"
                            title="Everything you ever wanted to know about Blockchain (but were afraid to ask)."
                            linkButton={{
                                label: 'Get the ebook',
                                link: () => {
                                    setShowEbookModal(true)
                                },
                                variant: 'secondary',
                            }}
                        />
                        <Container>
                            <FramerMotion y={300}>
                                <BlockchainEra />
                            </FramerMotion>
                        </Container>
                        <FramerMotion y={300}>
                            <SlideOffer />
                        </FramerMotion>
                        <Container>
                            <FramerMotion y={300}>
                                <AccordionComponent sectionTitle={accordionTitle} items={AccordionItems} />
                            </FramerMotion>
                        </Container>
                        <FramerMotion y={300}>
                            <Hero
                                customClass="powerBlockchain p-0"
                                colLg1={6}
                                colLg2={6}
                                title="The power of blockchain"
                                desc="Learn how Casper Labs is delivering impactful solutions to businesses and organizations worldwide."
                                linkButton={{
                                    label: 'See our case studies',
                                    link: '/customer-stories',
                                    variant: 'primary',
                                }}
                                bgImage={PowerBlockchainImage.src}
                            ></Hero>
                        </FramerMotion>
                        <Container>
                            <FramerMotion y={300}>
                                <CardsSection />
                            </FramerMotion>
                        </Container>
                        <Newsletter2 col1={5} col2={7} title="Sign up for our newsletter!" />
                    </main>
                </div>
                <HotspotModal
                    formId="42d4778a-690e-4d4e-b912-1d441d05caea"
                    target="#ebookForm"
                    showModal={showEbookModal}
                    handleClose={handleClose}
                >
                    <div id="ebookForm"></div>
                </HotspotModal>
            </FramerMotion>
        </>
    )
}
